/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nocountriesfound2Inputs */

const en_nocountriesfound2 = /** @type {(inputs: Nocountriesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No countries found`)
};

const de_nocountriesfound2 = /** @type {(inputs: Nocountriesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Länder gefunden`)
};

/**
* | output |
* | --- |
* | "No countries found" |
*
* @param {Nocountriesfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nocountriesfound2 = /** @type {((inputs?: Nocountriesfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nocountriesfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nocountriesfound2(inputs)
	return de_nocountriesfound2(inputs)
});
export { nocountriesfound2 as "noCountriesFound" }